module.exports = "<small *ngIf=\"model?.errors\" class=\"form-text text-muted\">{{errorMessage}}</small>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/errors/errors.component.html
// module id = ./src/app/core/components/errors/errors.component.html
// module chunks = main